export enum I18nDeprecate {
  NONE = 'none',
  FILE = 'file',
  PROJECT = 'project',
}
